import {
  currencyFormatter,
  currencyParser
} from 'features/ContractDetails/ContractDetailsGeneral/ContractDetailsForm/utils'
import {
  HOSPITAL_OPTIONS,
  THRESHOLD_MEASURED_IN_OPTIONS
} from './MarketShareRebateCondition/constants'

export const PERIOD_OPTIONS = [
  {
    label: 'Monthly',
    value: 'monthly'
  },
  {
    label: 'Quarterly',
    value: 'quarterly'
  },
  {
    label: 'Annually',
    value: 'annually'
  },
  {
    label: 'Semiannually',
    value: 'semiannually'
  }
]

export const REBATE_CONDITIONS_TYPE = {
  NO_REBATE: 'no_rebate',
  STRAIGHT_REBATE: 'straight',
  GROWTH_REBATE: 'growth',
  MARKET_SHARE_REBATE: 'market_share'
} as const

export const REBATE_CONDITIONS_TITLE = {
  no_rebate: 'No rebate',
  straight: 'Straight',
  growth: 'Growth',
  market_share: 'Market share'
} as const

export const REBATE_CONDITIONS_TYPE_NAME = {
  [REBATE_CONDITIONS_TYPE.NO_REBATE]: 'No rebate',
  [REBATE_CONDITIONS_TYPE.STRAIGHT_REBATE]: 'Straight rebate',
  [REBATE_CONDITIONS_TYPE.GROWTH_REBATE]: 'Growth rebate',
  [REBATE_CONDITIONS_TYPE.MARKET_SHARE_REBATE]: 'Market share rebate'
}

export const REBATE_CONDITIONS_TYPE_OPTIONS = Object.values(
  REBATE_CONDITIONS_TYPE
).map((type) => ({
  label: REBATE_CONDITIONS_TYPE_NAME[type],
  value: type
}))

export const INITIAL_REBATE_CONDITIONS = {
  [REBATE_CONDITIONS_TYPE.NO_REBATE]: {},
  [REBATE_CONDITIONS_TYPE.STRAIGHT_REBATE]: {
    amount: null,
    period_threshold: PERIOD_OPTIONS[1].value
  },
  [REBATE_CONDITIONS_TYPE.GROWTH_REBATE]: {
    purchase_volume_threshold: null,
    amount: null,
    period_threshold: PERIOD_OPTIONS[1].value
  },
  [REBATE_CONDITIONS_TYPE.MARKET_SHARE_REBATE]: {
    market_share_threshold: null,
    purchase_volume_threshold: null,
    amount: null,
    period_threshold: PERIOD_OPTIONS[1].value,
    apply_to_all_hospitals: HOSPITAL_OPTIONS[0].value,
    hospitals_rebates: [],
    is_tiered: false,
    threshold_measured_in: THRESHOLD_MEASURED_IN_OPTIONS[0].value
  }
}

export const PROPS_INPUT_NUMBER = {
  maxLength: 64,
  controls: false,
  placeholder: '0',
  formatter: currencyFormatter,
  parser: currencyParser
}
